import { createSlice } from '@reduxjs/toolkit';

const contentManagement = createSlice({
    name: 'items',
    initialState: {
        items: {},
    },
  reducers: {
    addContentManagement: (state, action) => {
        state.items = {};
        const { type, sections } = action.payload;
        state.items = {
            type,
            sections,
        };
    },

    clearItems: (state) => {
        state.items = {};
    },
  },
});

export const { addContentManagement, clearItems } = contentManagement.actions;
export default contentManagement.reducer;
